module.exports = __webpack_public_path__ + "img/FresnoC2C-Logo.26ded93c.png";